import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        const selectElement = this.el.querySelector('#file_categories');
        const fileItems = this.el.querySelectorAll('.c-box-files__item');

        if (selectElement) {
            // Sélectionne la première catégorie par défaut
            const firstOption = selectElement.querySelector('option[value]:not([value="all"])');
            if (firstOption) {
                firstOption.selected = true;
                this.filterItems(firstOption.value, fileItems);
            }

            // Ajoute un écouteur pour gérer les changements de catégorie
            selectElement.addEventListener('change', function () {
                const selectedCategory = this.value;
                fileItems.forEach(item => {
                    const categories = item.getAttribute('data-categories')?.split(' ') || [];

                    if (selectedCategory === 'all' || categories.includes(selectedCategory)) {
                        item.style.display = 'block'; // Affiche l'élément
                    } else {
                        item.style.display = 'none'; // Masque l'élément
                    }
                });
            });
        }
    }

    filterItems(selectedCategory, fileItems) {
        fileItems.forEach(item => {
            const categories = item.getAttribute('data-categories')?.split(' ') || [];

            if (selectedCategory === 'all' || categories.includes(selectedCategory)) {
                item.style.display = 'block'; // Affiche l'élément
            } else {
                item.style.display = 'none'; // Masque l'élément
            }
        });
    }
}
